import { createI18n } from 'vue-i18n'
import zhCN from './locales/zh-CN.json'
import enUS from './locales/en-US.json'
import fiFI from './locales/fi-FI.json'

const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: 'en-US', // 默认语言
  fallbackLocale: 'en-US', // 回退语言
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS,
    'fi-FI': fiFI
  },
  globalInjection: true, // 全局注入 $t
  missingWarn: process.env.NODE_ENV !== 'production', // 生产环境关闭警告
  fallbackWarn: process.env.NODE_ENV !== 'production'
})

export default i18n
